import { render, staticRenderFns } from "./ticket-detail.vue?vue&type=template&id=08da50fa&scoped=true&"
import script from "./ticket-detail.vue?vue&type=script&lang=js&"
export * from "./ticket-detail.vue?vue&type=script&lang=js&"
import style0 from "./ticket-detail.vue?vue&type=style&index=0&id=08da50fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08da50fa",
  null
  
)

export default component.exports